const pctText = (n) => `${(n ?? 0).toFixed(1)}%`;

const REPORT_LABEL = {
  multi: "Multi",
  win: "Win",
  place: "Place",
  eachway: "Each-Way",
};
const HEADLINE_SUB = {
  multi: "#1 tip placed within range",
  win: "#1 tip won",
  place: "#1 tip placed within range",
  eachway: "#1 tip placed (each-way)",
};
const ROI_SUB = {
  multi: "place dividend approx · flat stake",
  win: "win odds at SP · flat stake",
  place: "place dividend approx · flat stake",
  eachway: "½ win + ½ place · flat stake",
};

/** The four headline cards at the top of the summary dashboard. */
export default function SummaryCards({ summary, type = "multi" }) {
  const { headline, anyTip, racesAnalysed, tracks, roi } = summary;
  const roiPositive = roi >= 0;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
      <Card>
        <Label>{REPORT_LABEL[type] || "Multi"} success rate</Label>
        <div className="mt-1 flex items-end gap-2">
          <span className="text-3xl font-bold text-emerald-600">
            {pctText(headline.rate)}
          </span>
          <span className="text-xs text-slate-400 pb-1">
            · {headline.legs} legs
          </span>
        </div>
        <Sub>{HEADLINE_SUB[type] || HEADLINE_SUB.multi}</Sub>
      </Card>

      <Card>
        <Label>Any-tip in range</Label>
        <div className="mt-1 flex items-end gap-2">
          <span className="text-3xl font-bold text-slate-700">
            {pctText(anyTip.rate)}
          </span>
          <span className="text-xs text-slate-400 pb-1">
            · {anyTip.races} races
          </span>
        </div>
        <Sub>≥1 Lexi tip placed</Sub>
      </Card>

      <Card>
        <Label>Races analysed</Label>
        <div className="mt-1 text-3xl font-bold text-slate-700">
          {racesAnalysed}
        </div>
        <Sub>across {tracks} tracks</Sub>
      </Card>

      <Card>
        <Label>
          ROI @ SP <span className="text-slate-300">(stretch)</span>
        </Label>
        <div className="mt-1 flex items-end gap-2">
          <span
            className={
              roiPositive
                ? "text-3xl font-bold text-emerald-600"
                : "text-3xl font-bold text-red-500"
            }
          >
            {roiPositive ? "+" : ""}
            {(roi ?? 0).toFixed(1)}%
          </span>
        </div>
        <Sub>{ROI_SUB[type] || ROI_SUB.multi}</Sub>
      </Card>
    </div>
  );
}

function Card({ children }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4">
      {children}
    </div>
  );
}
function Label({ children }) {
  return (
    <div className="text-[11px] font-medium text-slate-400 uppercase">
      {children}
    </div>
  );
}
function Sub({ children }) {
  return <div className="text-[11px] text-slate-400 mt-1">{children}</div>;
}
